import React from 'react';
import Layout from '../components/Layout';
import useScrollTransition from '../useScrollTransition';
import LandingHeader from '../components/servicepage/landingheader';
import ScrollingText from '../components/lettersslider';
import Stats from '../components/status';
import FeaturesComponent from '../components/featurecard';
import LegalBriefComponent from '../components/aboutusinfo';
import CardComponent from '../components/landingservicecard';
import ServiceCardsGrid from '../components/landingservicecard';
import TestimonialCarousel from './star-rating';
import FaqSection from '../components/faqsection';
import ContactForm from '../components/servicecontact';
import LandingNavbar from '../components/landingnavbar';
import Footer from '../components/Footer';
import { Box } from '@mui/material';
import ExploreProjects from '../components/gallery';
import ProjectsGrid from '../components/gallery';
import LandingAbout from '../components/landingabout';
import FreebiesSection from '../components/landingfreebies';
import WhatsAppButton from '../components/whatsappmessage';


const LandingPage = () => {
  useScrollTransition();
  return (
    <>
    <Box sx={{backgroundColor:"#f3f4f6"}}>
    <LandingNavbar/>

        <LandingHeader />
        <ScrollingText/>
        <ServiceCardsGrid/>
        <LandingAbout/>
        <FeaturesComponent/>
        <Stats/>
        <ProjectsGrid/>
        <FaqSection/>
        {/* <TestimonialCarousel/> */}
        <FreebiesSection/>
        <WhatsAppButton/>
      
       
        
    <Footer/>
    </Box>
    </>
  );
};

export default LandingPage;